module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0933.edff7b9a.jpg";